import { getToken } from "./utils"

// src/api/guests.js
const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000");

export async function getGuests(eventId) {
  const response = await fetch(`${API_URL}/events/${eventId}/guests`);
  if (!response.ok) throw new Error("Failed to load guests");
  return await response.json();
}

export async function addGuest(eventId, guest) {
  const response = await fetch(`${API_URL}/events/${eventId}/guests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(guest),
  });
  if (!response.ok) throw new Error("Failed to add guest");
  return await response.json();
}


export const getGuestsForUser = async (eventId) => {
  const res = await fetch(`${API_URL}/guests/${eventId}/guests`, {
    method: "GET",
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  return await res.json();
};

export const addGuestsToEvent = async (eventId, guests) => {
  console.log(JSON.stringify(guests))

  const res = await fetch(`${API_URL}/guests/${eventId}/guests`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(guests)
  });
  
  return await res.json();
};

export const updateRSVP = async (eventGuestId, subeventId, rsvp) => {
  const res = await fetch(`${API_URL}/guests/${eventGuestId}/rsvp/${subeventId}`, rsvp, {
    method: "PUT",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify(rsvp),
  });
  return await res.data;
};

